module.exports = __webpack_public_path__ + "media/assets/calendar-d424fadce98dbf86c335d94f89f45c70351c4fba0644bb42029bd9f8e1913a21.svg";